// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EZKS","right":"styles_right___ffXG"};